import type { ReactNode } from "react";

export const SectionFourActionTypes = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  VIEW: "VIEW",
  STATUS: "STATUS",
} as const;

export type SectionFourActionEnum =
  (typeof SectionFourActionTypes)[keyof typeof SectionFourActionTypes];

export type ModalState = {
  visible: boolean;
  title: string;
  info: string | ReactNode;
  confirmText: string;
  cancelText: string;
  inputPlaceholder?: string;
  inputValue?: string;
  isInputModal?: boolean;
  action: string | null;
  signerEmployeeId?: string | null;
  actionPayload?: any;
  sectionTwoAction?: SectionFourActionEnum | null;
  isDivider?: boolean;
};
